module.exports = __webpack_public_path__ + "media/print/images-per-page_16-2297934f.png";